<div
  fxLayout="column"
  fxLayoutAlign="space-between"
  [routerLink]="['/settings/licensing']"
  (click)="quickPanelService.onSetOpen(false)"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between"
  >
    <h2><i class="mdi mdi-license s18 mr-5 orange-fg"></i>{{ alert.title }}</h2>
  </div>
  <div>{{ alert.description }}</div>
</div>
